import { OrderProductsWithErrors } from '../../../../../services/modules/order-product/order-product.types';
import { Collection } from '../../../../collections/collections.types';
import { AvailabilityEnum, DeliveryWindow } from '../../../../products/ProductTypes';
import { ColorClassification } from '../../../../products/product.types.v2';
import { GroupByColorClassificationTypeInfo, ListCategoryDTO } from '../../orderProducts.types';

export type OrderProductsSorter = {
  availability?: AvailabilityEnum;
  category?: ListCategoryDTO;
  code?: string;
  collection?: Collection;
  deliveryWindow?: DeliveryWindow;
  productColorId?: string;
  subCategory?: ListCategoryDTO;
  colorClassifications?: ColorClassification[];
};

export interface OrderProductsSorterSortParams<T> {
  orderProducts: T[];
  info?: GroupByColorClassificationTypeInfo;
  orderProductsWithErrors?: OrderProductsWithErrors;
}

abstract class OrderProductsSorterBuilder {
  public abstract sort<T extends OrderProductsSorter>({
    orderProducts,
    orderProductsWithErrors,
    info,
  }: OrderProductsSorterSortParams<T>): T[];
}

export default OrderProductsSorterBuilder;
